// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionLog, ActionLogT } from '../tbs/action-log.js';
import { State, StateT } from '../tbs/state.js';


export class Replay implements flatbuffers.IUnpackableObject<ReplayT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):Replay {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsReplay(bb:flatbuffers.ByteBuffer, obj?:Replay):Replay {
  return (obj || new Replay()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsReplay(bb:flatbuffers.ByteBuffer, obj?:Replay):Replay {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new Replay()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

initialState(obj?:State):State|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new State()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

logs(index: number, obj?:ActionLog):ActionLog|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new ActionLog()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

logsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

static startReplay(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addInitialState(builder:flatbuffers.Builder, initialStateOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, initialStateOffset, 0);
}

static addLogs(builder:flatbuffers.Builder, logsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, logsOffset, 0);
}

static createLogsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startLogsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static endReplay(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createReplay(builder:flatbuffers.Builder, initialStateOffset:flatbuffers.Offset, logsOffset:flatbuffers.Offset):flatbuffers.Offset {
  Replay.startReplay(builder);
  Replay.addInitialState(builder, initialStateOffset);
  Replay.addLogs(builder, logsOffset);
  return Replay.endReplay(builder);
}

unpack(): ReplayT {
  return new ReplayT(
    (this.initialState() !== null ? this.initialState()!.unpack() : null),
    this.bb!.createObjList<ActionLog, ActionLogT>(this.logs.bind(this), this.logsLength())
  );
}


unpackTo(_o: ReplayT): void {
  _o.initialState = (this.initialState() !== null ? this.initialState()!.unpack() : null);
  _o.logs = this.bb!.createObjList<ActionLog, ActionLogT>(this.logs.bind(this), this.logsLength());
}
}

export class ReplayT implements flatbuffers.IGeneratedObject {
constructor(
  public initialState: StateT|null = null,
  public logs: (ActionLogT)[] = []
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const initialState = (this.initialState !== null ? this.initialState!.pack(builder) : 0);
  const logs = Replay.createLogsVector(builder, builder.createObjectOffsetList(this.logs));

  return Replay.createReplay(builder,
    initialState,
    logs
  );
}
}
